import { Accordion } from "radix-ui";
import Text from "../../molecules/content/Text";

export const AccordionContent = ({ children, ...props }) => {
  return (
    <Accordion.Content
      className={
        "overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down pl-4 pb-3"
      }
      {...props}
    >
      <Text variant="peak">{children}</Text>
    </Accordion.Content>
  );
};
